import React from 'react'
import CardHowItWork from '../../components/CardHowItWork'
import ArrowBack from '../../components/ArrowBack'

import { ContainerWrapper, ContainerCards, ButtonContainer } from './styled'
import Button from "../../components/Button";
import { Link } from 'react-router-dom';

import { FaWrench } from 'react-icons/fa';
import img1 from '../../assets/ImagesTutorial/image-1.png'
import img2 from '../../assets/ImagesTutorial/image-2.png'
import img3 from '../../assets/ImagesTutorial/image-3.png'
import img4 from '../../assets/ImagesTutorial/image-4.png'
import img5 from '../../assets/ImagesTutorial/image-5.png'
import img6 from '../../assets/ImagesTutorial/image-6.png'

const PageHowItWork = () => {

    const returnElements = [
        {
            id: 1,
            title: "1° passo - Crie sua conta e faça o login",
            phrases: ["Preencha seus dados pessoais e crie seu cadastro", "Faça o login em sua conta"],
            image: img1
        },

        {
            id: 2,
            title: "2° passo - Adquira seu Pacote ",
            phrases: ["Adquira seu pacote Vai de Férias"],
            image: img2
        },

        {
            id: 3,
            title: "3° passo - Efetue o Pagamento em até 24x",
            phrases: ["Escolha seu método de pagamento preferido"],
            image: img3
        },

        {
            id: 4,
            title: "4° passo - Realize sua Reserva",
            phrases: ["Escolha seu destino favorito", "Acompanhe seu pedido pelo seu perfil"],
            image: img4
        },
        {
            id: 5,
            title: "5° passo - Acompanhe sua Solicitação de Reserva",
            phrases: ["Verifique o processsamento da solicitação pelo seu perfi", "Entre em contato conosco"],
            image: img5
        },
        {
            id: 6,
            title: "6° passo - Vai de Férias!",
            phrases: ["Sua hospedagem no Hotel escolhido está garantida", "Relaxe, tire fotos e tenha as férias dos seus sonhos!"],
            image: img6
        }
    ]

    return (
        <>
            <ArrowBack/>
            <ContainerWrapper>
                <div className="header-style">
                    <h1><FaWrench /> Como adquirir suas férias</h1>
                    <p>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam, eaque
                    natus error sit voluptatem
                    accusantium doloremque laudantium, totam rem aperiam</p>
                </div>
                    <ContainerCards>
                        {returnElements?.map((element) => (
                            <CardHowItWork
                                key={element.id}
                                title={element.title}
                                description={element.phrases}
                                image={element.image}
                            />
                        ))}
                    </ContainerCards>
                    <ButtonContainer>
                        <Link to='/sign_up'>
                            <Button format="submit">Faça seu cadastro agora</Button>
                        </Link>
                    </ButtonContainer>
            </ContainerWrapper>
        </>
    )
}

export default PageHowItWork
